const FilterIcon = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2513 3.0625H8.16797C7.9288 3.0625 7.73047 2.86417 7.73047 2.625C7.73047 2.38583 7.9288 2.1875 8.16797 2.1875H12.2513C12.4905 2.1875 12.6888 2.38583 12.6888 2.625C12.6888 2.86417 12.4905 3.0625 12.2513 3.0625Z"
      fill="currentColor"
    />
    <path
      d="M12.2513 5.979H8.16797C7.9288 5.979 7.73047 5.78067 7.73047 5.5415C7.73047 5.30234 7.9288 5.104 8.16797 5.104H12.2513C12.4905 5.104 12.6888 5.30234 12.6888 5.5415C12.6888 5.78067 12.4905 5.979 12.2513 5.979Z"
      fill="currentColor"
    />
    <path
      d="M12.25 8.896H1.75C1.51083 8.896 1.3125 8.69766 1.3125 8.4585C1.3125 8.21933 1.51083 8.021 1.75 8.021H12.25C12.4892 8.021 12.6875 8.21933 12.6875 8.4585C12.6875 8.69766 12.4892 8.896 12.25 8.896Z"
      fill="currentColor"
    />
    <path
      d="M12.25 11.8125H1.75C1.51083 11.8125 1.3125 11.6142 1.3125 11.375C1.3125 11.1358 1.51083 10.9375 1.75 10.9375H12.25C12.4892 10.9375 12.6875 11.1358 12.6875 11.375C12.6875 11.6142 12.4892 11.8125 12.25 11.8125Z"
      fill="currentColor"
    />
    <path
      d="M4.6213 6.271H2.96464C2.0663 6.271 1.60547 5.816 1.60547 4.91183V3.25516C1.60547 2.35683 2.06047 1.896 2.96464 1.896H4.62714C5.52547 1.896 5.9863 2.351 5.9863 3.25516V4.91766C5.98047 5.816 5.52547 6.271 4.6213 6.271ZM2.96464 2.771C2.55047 2.771 2.48047 2.841 2.48047 3.25516V4.91766C2.48047 5.33183 2.55047 5.40183 2.96464 5.40183H4.62714C5.0413 5.40183 5.1113 5.33183 5.1113 4.91766V3.25516C5.1113 2.841 5.0413 2.771 4.62714 2.771H2.96464Z"
      fill="currentColor"
    />
  </svg>
);
export default FilterIcon;
